import { IMAGE } from "../../image/image";

export const CommunityTools = () => {
  return (
    <div className="container">
      <div className="section">
        <div className="community-tools-container">
          <div>
            <img
              className="width-rocket-img"
              src={IMAGE.HOMEPAGE.COMMUNITY_TOOLS}
              alt="homieverse community tools"
            ></img>
          </div>
          <div className="community-tools-text-container">
            <div className="out-fit-title-text-mini">
              First ever<br></br> community tool
            </div>
            <div className="set-desktop out-fit-detail-text mt-20">
              Our tool is designed to provide market insight <br></br> and
              allowing users to manage the data as a <br></br> community. The
              interactive calendar allowing the <br></br>community to share,
              respond, organiz, and analyze <br></br> as a team.
            </div>

            <div className="set-mobile out-fit-detail-text mt-20">
              Our tool is designed to provide market insight and allowing users
              to manage the data as a community. The interactive calendar
              allowing the community to share, respond, organiz, and analyze as
              a team.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
